// extracted by mini-css-extract-plugin
export var grid = "WeAlsoWorkWith-module--grid--b7c7e";